import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ContactManagerLinkProps {
  showContacts?: boolean;
}

const PHONE = '+7 (937) 183-00-05';
const TELEGRAM = '@ctotek';

export function ContactManagerLink({ showContacts = false }: ContactManagerLinkProps) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  function handleClick() {
    if (showContacts) {
      setExpanded(!expanded);
    } else {
      navigate('/callback');
    }
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <button
        type="button"
        onClick={handleClick}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 0',
          fontSize: '14px',
          color: 'var(--tgui--link_color, #2196F3)',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07
            19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1
            4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0
            1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1
            2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
        Связаться с менеджером
      </button>

      {showContacts && expanded && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '8px 0',
          fontSize: '14px',
        }}>
          <a
            href={`tel:${PHONE.replace(/[\s()-]/g, '')}`}
            onClick={(e) => {
              e.preventDefault();
              const tg = (window as any).Telegram?.WebApp;
              const telUrl = `tel:${PHONE.replace(/[\s()-]/g, '')}`;
              if (tg?.openLink) {
                tg.openLink(telUrl);
              } else {
                window.location.href = telUrl;
              }
            }}
            style={{ color: 'var(--tgui--link_color, #2196F3)' }}>
            {PHONE}
          </a>
          <a href="https://t.me/ctotek"
            style={{ color: 'var(--tgui--link_color, #2196F3)', display: 'inline-flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12.056 0h-.112ZM17.9 7.2l-2.02 9.52c-.145.68-.54.845-1.095.525l-3.03-2.23-1.46 1.405c-.16.16-.3.3-.615.3l.21-3.06 5.56-5.025c.24-.215-.055-.335-.375-.12l-6.87 4.326-2.96-.924c-.64-.204-.655-.644.136-.953l11.57-4.46c.535-.196 1.005.13.83.944h.12Z"/>
            </svg>
            {TELEGRAM}
          </a>
        </div>
      )}
    </div>
  );
}
